import React from 'react';
import PropTypes from 'prop-types';
import BodyText from 'components/widget/BodyText';
import Paper from 'components/Paper';
import { ReactComponent as StoreFrontSvg } from 'images/store-front.svg';
import styled from 'styled-components';
import Button from 'components/Button';

const COUNTRY_COPY = {
  UK: {
    title: 'Your store is in the UK',
    body: (linkLabel, linkHref) => (
      <BodyText>
        Because your store is based in the UK please use
        {' '}
        <a href={linkHref}>{linkLabel}</a>
        {' '}
        to access your easycare account
      </BodyText>
    ),
  },
  IE: {
    title: 'Your store is in Ireland',
    body: (linkLabel, linkHref) => (
      <BodyText>
        Because your store is based in Ireland please use
        {' '}
        <a href={linkHref}>{linkLabel}</a>
        {' '}
        to access your easycare account
      </BodyText>
    ),
  },
};

const StyledWrongCountryView = styled.div`
  a.alternativeSiteCta {
    color: ${({ theme }) => theme.palette.colors.green1};
    font-size: 1.2rem;
    text-decoration: none;
  }
`;

const ImageWrapper = styled.div`
  text-align: center;
  svg {
    height: 104px;
    width: auto;
  }
`;

const ViewContent = styled.div`
  display: flex;
  > *:first-child {
    flex-grow: 1;
  }
`;

const WrongCountryView = ({ alternativeCountry, siteUrl, siteLabel }) => (
  <StyledWrongCountryView>
    <Paper>
      <ViewContent>
        <div>
          <h2>{COUNTRY_COPY[alternativeCountry].title}</h2>
          <p>
            {COUNTRY_COPY[alternativeCountry].body(siteLabel, siteUrl)}
          </p>
        </div>
        <ImageWrapper>
          <StoreFrontSvg />
        </ImageWrapper>
      </ViewContent>
      <Button onClick={() => { window.location = siteUrl; }}>
        Go&nbsp;to
        {' '}
        {siteLabel}
      </Button>
    </Paper>
  </StyledWrongCountryView>
);

WrongCountryView.propTypes = {
  alternativeCountry: PropTypes.oneOf(['IE', 'UK']).isRequired,
  siteLabel: PropTypes.string.isRequired,
  siteUrl: PropTypes.string.isRequired,
};

export default WrongCountryView;
